export enum PartOfDay {
  FullDay = 'FULL_DAY',
  FirstHalf = 'FIRST_HALF',
  SecondHalf = 'SECOND_HALF',
  FirstQuarter = 'FIRST_QUARTER',
  SecondQuarter = 'SECOND_QUARTER',
  ThirdQuarter = 'THIRD_QUARTER',
  FourthQuarter = 'FOURTH_QUARTER',
  Custom = 'CUSTOM',
}
